import React, { useMemo } from 'react';
import { Progress } from 'tea-component';
import classnames from 'classnames';
import './index.scss';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { reviewsFormat } from '@op/utils/value';
import CompareProgressBubble from '../CompareProgressBubble';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { MetricsItemType } from '@op/components/FilterCommon/widgets/MetricsSelect/config';

type ProgressProps = {
  className?: string;
  showProgress?: boolean;
  percentage: number;
  value: number;
  hideTrend?: boolean;
  totalValue?: number;
  formateValue?: (value: any) => string | number;
  formateDate?: (date: string) => string;
  color?: string;
  gameInfo: any;
  title?: string;
  startTime: string;
  endTime: string;
  extraBubbleContent?: React.ReactNode;
  oldStartTime?: string;
  oldEndTime?: string;
  oldValue?: number;
  showChange?: boolean;
  data: any;
  metricInfo: MetricsItemType;
  valueKey: string;
};

function getProgressValue(data: any, metricInfo: MetricsItemType) {
  const { value: key, processType } = metricInfo;
  const value = data[key];

  if (typeof value !== 'number' || isNaN(value)) return 0;

  if (processType === 'brand_health') {
    return (value + 100) / 200;
  }

  if (typeof processType === 'number') {
    return value / processType;
  }

  const maxKey = key + '_max';
  const maxValue = data[maxKey];
  if (typeof maxValue !== 'number') return 0;
  return value / maxValue;
}

const CompareProgressColumn = (props: ProgressProps) => {
  const {
    className,
    showProgress = false,
    percentage,
    value,
    hideTrend,
    formateValue = reviewsFormat,
    formateDate,
    color = '#5086f3',
    gameInfo,
    title,
    startTime,
    endTime,
    extraBubbleContent,
    oldStartTime,
    oldEndTime,
    oldValue,
    showChange = false,
    data,
    metricInfo, 
  } = props;

  let width = getProgressValue(data, metricInfo);
  if (width > 1) width = 1;

  return (
    <div className={classnames('dbo-compare-progress-column', className)}>
      <PercentageItem className="dbo-numtrends" percentage={percentage}>
        {(percentageElement: any) => (
          <>
            <CompareProgressBubble
              title={title}
              name={
                <div className={`dbo-bubble-box-game`}>
                  <RenderGameIcon
                    gameInfo={gameInfo}
                    className="game-icon"
                  ></RenderGameIcon>
                  <span className={'game-name'}>{gameInfo.entity_name}</span>
                </div>
              }
              value={value}
              startTime={startTime}
              endTime={endTime}
              formatDate={formateDate}
              formatValue={formateValue}
              extraContent={extraBubbleContent}
              showChange={showChange}
              oldStartTime={oldStartTime}
              oldEndTime={oldEndTime}
              oldValue={oldValue}
            >
              <span className={`dbo-numtrends-num`}>{formateValue(value)}</span>
              {!hideTrend && percentageElement}
            </CompareProgressBubble>
          </>
        )}
      </PercentageItem>
      {showProgress && (
        <div className="progress-bar-container">
          <Progress
            className="progress-bar"
            percent={width * 100}
            strokeWidth={6}
            strokeColor={color}
            theme={'default'}
          />
        </div>
      )}
    </div>
  );
};

export default CompareProgressColumn;
